var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "row no-margin", attrs: { id: "header" } },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("div", { staticClass: "left row no-margin align-items-center" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn-backtohome",
                attrs: { to: { name: "Home" } }
              },
              [_c("i", { staticClass: "fas fa-th" })]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "middle row align-items-center",
          staticStyle: { "padding-right": "10px", position: "relative" }
        },
        [
          _vm.showDiv2 && _vm.getAppPrev.app_id
            ? _c(
                "div",
                {
                  staticClass:
                    "subheader col no-padding text-right animated fastest",
                  class: [{ slideOutUp: _vm.animiated2 }],
                  staticStyle: { "margin-left": "15px" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("app." + _vm.getAppPrev.app_name + ".title")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "icon-box",
                      style:
                        "background:" +
                        _vm.$t("app." + _vm.getAppPrev.app_name + ".bgcolor")
                    },
                    [
                      _c("i", {
                        class: _vm.$t(
                          "app." + _vm.getAppPrev.app_name + ".icon"
                        )
                      })
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showDiv1
            ? _c(
                "div",
                {
                  staticClass:
                    "subheader col no-padding text-right animated fast",
                  class: [{ slideInDown: _vm.animiated1 }],
                  staticStyle: { "margin-left": "15px" }
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("app." + _vm.getAppCurrent.app_name + ".title")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "icon-box",
                      style:
                        "background:" +
                        _vm.$t("app." + _vm.getAppCurrent.app_name + ".bgcolor")
                    },
                    [
                      _c("i", {
                        class: _vm.$t(
                          "app." + _vm.getAppCurrent.app_name + ".icon"
                        )
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn-no-bg", attrs: { id: "btn-show-sidebar-toggle" } },
      [_c("i", { staticClass: "fas fa-bars" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cfb9af8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfb9af8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/Header.vue
// module id = null
// module chunks = 